// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"532":"00649e2ddbc5894d03ae","678":"b8a16c443e419851e8fc","731":"ef36a66950fc491edf75","843":"ce57dfb59545c24bfd8b","883":"2205e9eb8803b6acc8ac"}[chunkId] + ".js";
};